// extracted by mini-css-extract-plugin
export default {"agreementText":"AgreementTextV5_agreementText-t82"};